import 'whatwg-fetch';
var LocalizationLoader = /** @class */ (function () {
    function LocalizationLoader() {
        var _this = this;
        this.fallBackLanguage = "en-US";
        this.location = "assets/js/i18n/l_";
        this.availableLanguages = [];
        this.getLanguageUrl = function (location, language) {
            return "" + location + language + ".json";
        };
        this.updateLanguageOnFail = function (language) {
            return language.length > 2 ? language.substr(0, 2) : _this.fallBackLanguage;
        };
        this.retryOnFail = function (language) {
            var otherLanguage = _this.updateLanguageOnFail(language);
            if (otherLanguage !== language) {
                return _this.loadLanguage(otherLanguage);
            }
            throw new Error("no localization found!");
        };
        this.loadOptionalLocaleExtension = function (location) {
            var url = _this.getLanguageUrl(location, _this.loadedLanguage);
            return fetch(url)
                .then(function (response) { return response.json(); })
                .catch(function (e) {
                console.warn("Failed loading language file " + url, e);
                return {};
            });
        };
        this.loadLanguage = function (language) {
            language = language.toLowerCase();
            if (!_this.fallBackLanguage || _this.availableLanguages.length === 0) {
                throw new Error("Localization module not initialized correctly");
            }
            if (_this.availableLanguages.indexOf(language) === -1) {
                return _this.retryOnFail(language);
            }
            _this.loadedLanguage = language;
            return fetch(_this.getLanguageUrl(_this.location, language))
                .then(function (response) { return response.json(); });
        };
        this.setFallBackLanguage = function (_fallBackLanguage) {
            return _this.fallBackLanguage = _fallBackLanguage;
        };
        this.setAvailableLanguages = function (_availableLanguages) {
            return _this.availableLanguages = _availableLanguages;
        };
    }
    return LocalizationLoader;
}());
export default new LocalizationLoader();



//////////////////
// WEBPACK FOOTER
// ./js/i18n/localization.loader.ts
// module id = iuSa
// module chunks = 1 2 3 4